import { render } from "./AuthorizationRegistryGrantsShowView.vue?vue&type=template&id=158dcfb2"
import script from "./AuthorizationRegistryGrantsShowView.vue?vue&type=script&lang=js"
export * from "./AuthorizationRegistryGrantsShowView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__